import { __assign } from "tslib";
import React, { useContext } from 'react';
import omit from 'lodash/omit';
import classnames from 'classnames';
import Button from '../../../../Button';
import BrandedButton from '@wix/da-ds/pkg/Buttons/BrandedButton';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import s from './FooterButton.scss';
var FooterButton = function (props) {
    var _a;
    var view = props.view, height = props.height, _b = props.size, size = _b === void 0 ? 'medium' : _b, className = props.className;
    var isMobile = useContext(MobileContext);
    var fullWidth = (_a = props.fullWidth) !== null && _a !== void 0 ? _a : isMobile;
    return view === undefined ? (React.createElement(BrandedButton
    // Take SolidButton doesn't have a height prop, so remove it
    , __assign({}, omit(props, ['height']), { variant: "brand-green", size: size, className: classnames(s['new-ds-footer-btn'], fullWidth && s['full-width'], s[size], props.className) }))) : (React.createElement(Button, __assign({}, props, { height: height || size, className: classnames(s['footer-btn'], fullWidth && s['full-width'], className) })));
};
FooterButton.displayName = 'FooterButton';
export default FooterButton;
//# sourceMappingURL=FooterButton.js.map